<template>
  <div>
    <select v-model="lang">
      <option v-for="locale in locales" :key="locale.code" :value="locale.code">{{locale.name}}</option>
    </select>
    <ul>
      <li>{{ $t('hello') }}</li>
      <li>{{ $t('helloWithParams', {'name': 'covida'}) }}</li>
      <li>Pluralization:</li>
      <li>{{ $tc('car', 1) }}</li>
      <li>{{ $tc('car', 2) }}</li>
      <li>{{ $tc('apple', 0) }}</li>
      <li>{{ $tc('apple', 1) }}</li>
      <li>{{ $tc('apple', 10, { count: 10 }) }}</li>
      <li>
        <a href="https://kazupon.github.io/vue-i18n/guide/formatting.html">more information</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getSupportedLocales } from "../../../setup/lang/supportedLocales";

export default {
  data: function() {
    return {
      locales: []
    };
  },

  computed: {
    lang: {
      get() {
        return this.$store.state.settings.lang;
      },
      set(value) {
        this.$store.dispatch("changeLang", value);
      }
    }
  },

  mounted: function(){
    this.locales = getSupportedLocales();
  }
};
</script>

<style>
</style>